module.exports = __webpack_public_path__ + "img/parpar_yes.ef1eb6c4.png";